import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-light-bulb",
  "use": "icon-si-glyph-light-bulb-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-light-bulb\" id=\"icon-si-glyph-light-bulb\"><title>825</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(3.000000, 0.000000)\" fill=\"#434343\"><path d=\"M10,3.991 C10,1.422 7.729,0.015 5,0.015 C2.271,0.015 0,1.421 0,3.991 C0,7.29 2.087,8.188 3.312,10.269 C3.576,10.718 2.822,10.496 3.077,10.952 L6.895,10.952 C7.147,10.5 6.3,10.723 6.562,10.276 C7.782,8.192 10,7.375 10,3.991 L10,3.991 Z\" class=\"si-glyph-fill\" /><rect x=\"3\" y=\"12\" width=\"3.953\" height=\"0.922\" class=\"si-glyph-fill\" /><path d=\"M6.969,14.968 C6.969,15.529 6.535,15.985 5.998,15.985 L4.014,15.985 C3.476,15.985 3.042,15.529 3.042,14.968 L3.042,14.021 L6.969,14.021 L6.969,14.968 L6.969,14.968 Z\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-light-bulb.svg
// module id = 2+Qu
// module chunks = 62